export default "__VITE_ASSET__CSIFazx8__"